import * as types from "./breadcrumb.actionsType";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  currentBreadcrumb: []
});

export default function reduce(state = initialState, action = {}) {
  switch (action.type) {
    case types.SET_BREADCRUMB:
      return state.merge(action.payload);
    default:
      return state;
  }
}
